import { render, staticRenderFns } from "./Erfolgsrechnung.vue?vue&type=template&id=9db39850&"
import script from "./Erfolgsrechnung.vue?vue&type=script&lang=ts&"
export * from "./Erfolgsrechnung.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports